
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[franchiseeSlug]",
      function () {
        return require("private-next-pages/[franchiseeSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[franchiseeSlug]"])
      });
    }
  